<template>
  <div class="layer">
    <!-- 基本信息 -->
    <el-row :gutter="20" v-loading='loading' class="width">
      <el-col :span="20" :offset="2" style="min-height: 90vh;">
        <div class="basic">
          <img
            :src="nameOrgArray.avatarUrl ?nameOrgArray.avatarUrl : 'http://expert.ckcest.cn/autoload/images/avatar.png'"
            alt
            class="basic_img"
          />
          <div class="basic_info">
            <div class="info_inp">
              <div class="info_set">
                <img src='http://expert.ckcest.cn/autoload/images/avatar.png' alt />
                <el-input
                  v-model="nameOrgArray.name"
                  disabled
                  v-if="!/^[A-Za-z][A-Za-z\s]*[A-Za-z]$/.test(nameOrgArray.name)"
                ></el-input>
                <el-input v-model="name" v-else placeholder="请输入中文名称"></el-input>
              </div>
              <div class="info_set">
                <img src="http://expert.ckcest.cn/autoload/images/icon_phone.png" alt />
                <el-input v-model="user.Mobile" disabled></el-input>
              </div>
              <div class="info_set">
                <img src="http://expert.ckcest.cn/autoload/images/icon_major.png" alt />
                <el-input v-model="nameOrgArray.subject"></el-input>
              </div>
              <div class="info_set">
                <img
                  src="http://expert.ckcest.cn/autoload/images/icon_organization.png"
                  alt
                />
                <el-input
                  v-model="nameOrgArray.organization"
                  placeholder="请输入您所在单位的中文名称"
                  v-if="!/^[A-Za-z][A-Za-z\s]*[A-Za-z]$/.test(nameOrgArray.name)"
                ></el-input>
                <el-input v-model="organization" v-else placeholder="请输入您所在单位的中文名称"></el-input>
              </div>
              <div class="info_set">
                <img src="http://expert.ckcest.cn/autoload/images/icon_calendar.png" alt />
                <el-button type="primary" class="btn" @click="dialogFormVisible = true">上传履历</el-button>
              </div>
            </div>
          </div>
          <div class="basic_resume">
            <span>个人简历(请补全您的简历，目前是机器自动为您生成的简历，未必准确)</span>
            <el-input
              class="resume_input"
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="nameOrgArray.introduction"
              :disabled="isEdit"
            ></el-input>
            <el-button type="primary" @click="isEdit = !isEdit">{{isEdit?'修改':'保存'}}</el-button>
          </div>
        </div>
        <div class="table" v-if="Object.keys(tableData).length">
          <el-table :data="tableData" border>
            <el-table-column prop="startTime" label="起始日期" width="180"></el-table-column>
            <el-table-column prop="endTime" label="截止日期" width="180"></el-table-column>
            <el-table-column prop="institutions" label="机构"></el-table-column>
            <el-table-column prop="secInstitutions" label="二级机构"></el-table-column>
            <el-table-column prop="title" label="职称"></el-table-column>
            <el-table-column prop="position" label="职位"></el-table-column>
            <el-table-column prop="position" label="操作">
              <template slot-scope="scope">
                <el-button type="danger" @click="del(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="next">
          <el-button type="primary" @click="next()">确认进入下一步 » 选择您的成果</el-button>
        </div>
      </el-col>
    </el-row>
    <!-- 上传履历 -->
    <el-dialog title="上传履历" class="basicDialog" st :visible.sync="dialogFormVisible" center>
      <el-form :model="form" :rules="rules" ref="form" :label-width="formLabelWidth">
        <el-form-item label="起始时间" prop="startTime">
          <el-date-picker v-model="form.startTime" type="month" placeholder="选择起始时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="截止时间" prop="endTime">
          <el-date-picker v-model="form.endTime" type="month" placeholder="选择截止时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="所在机构" prop="institutions">
          <el-input v-model="form.institutions" autocomplete="off" placeholder="请输入机构名"></el-input>
        </el-form-item>
        <el-form-item label="二级机构">
          <el-input v-model="form.secInstitutions" autocomplete="off" placeholder="请输入二级机构名"></el-input>
        </el-form-item>
        <el-form-item label="职称">
          <el-input v-model="form.title" autocomplete="off" placeholder="请输入职称"></el-input>
        </el-form-item>
        <el-form-item label="职位">
          <el-input v-model="form.position" autocomplete="off" placeholder="请输入职位"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { claim } from '@/api/claim'
import { formatTime } from '@/utils/index'
export default {
  name: 'basic',
  data () {
    return {
      nameOrgArray: JSON.parse(localStorage.getItem('nameOrgArray')), // 专家信息
      user: JSON.parse(localStorage.getItem('user')), // 用户信息
      cid: this.$route.query.cid, // cid
      isEdit: true, // 是否可以编辑
      // 个人简介
      textarea:
        '根据数据搜索表明何冰晶（专家）可见的最早英文论文发表是2003年在Reactive and Functional Polymers（期刊）上的A novel bithiazole-tetrathiapentalene polymer and its metal complexes一文。截至2005年在MATERIALS CHEMISTRY AND PHYSICS、Reactive and Functional Polymers、SYNTHETIC METALS等3种期刊上共发文5篇。132123132',
      /* 履历部分 */
      dialogFormVisible: false,
      form: {
        startTime: '',
        endTime: '',
        institutions: '',
        secInstitutions: '',
        title: '',
        position: ''
      },
      rules: {
        startTime: [{ required: true, message: '请选择时间', trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择时间', trigger: 'blur' }],
        institutions: [
          { required: true, message: '请输入机构', trigger: 'blur' }
        ]
      },
      formLabelWidth: '120px',
      tableData: [],
      name: '',
      organization: '',
      loading: false
    }
  },
  methods: {
    // 上传履历
    submitForm (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.form.startTime = formatTime(this.form.startTime, '{y} - {m}')
          this.form.endTime = formatTime(this.form.endTime, '{y} - {m}')
          this.tableData.push(this.form)
          this.dialogFormVisible = false
        } else {
          return false
        }
      })
    },
    // 刪除履历
    del (index) {
      this.tableData.splice(index, 1)
    },
    // 下一步
    next () {
      let nameOrgArray = this.nameOrgArray
      nameOrgArray.Introduction = nameOrgArray.introduction || '暂无简历信息'
      nameOrgArray.Organization = nameOrgArray.organization
      nameOrgArray.Subject = nameOrgArray.subject
      if (!nameOrgArray.kId) {
        if (/^[A-Za-z][A-Za-z\s]*[A-Za-z]$/.test(this.name)) {
          this.$message({
            message: '必须输入您的中文姓名',
            offset: '200'
          })
          return
        }
        nameOrgArray.altName = nameOrgArray.name
        nameOrgArray.altOrganization = nameOrgArray.organization
        nameOrgArray.improtTime = new Date()
        nameOrgArray.operateTime = new Date()
        nameOrgArray.name = this.name
        nameOrgArray.organization = this.organization
      }
      let expertResume = []
      this.tableData.forEach((item, index) => {
        let temp = {
          Id: this.user.Id,
          KId: nameOrgArray.Kid,
          Organization: {
            IsSystem: false,
            IsValid: true,
            Id: '',
            Name: item.institutions
          },
          Department: item.secInstitutions,
          BeginDate: item.startTime,
          EndDate: item.endTime,
          PositionalTitle: item.title,
          Position: item.position
        }
        expertResume.push(temp)
      })
      this.loading = true
      let data = {
        UserId: this.user.Id,
        EmployeeId: 0,
        Expert: nameOrgArray,
        ExpertResumes: expertResume
      }
      claim(data)
        .then(res => {
          this.$message({
            message: res.msg,
            offset: '200'
          })
          if (res.status) {
            this.$router.push({
              path: '/claim/research',
              query: { Kid: res.data.Data.KId, resourcetoken: res.resourcetoken }
            })
          }
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  watch: {
    dialogFormVisible: {
      deep: true,
      handler () {
        this.form = {
          startTime: '',
          endTime: '',
          institutions: '',
          secInstitutions: '',
          title: '',
          position: ''
        }
      }
    }
  },
  mounted () {
    // 未登录以及一枚cid返回首页
    if (!this.cid || !localStorage.getItem('user')) {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style lang="scss">
.basic {
  height: 250px;
  margin-top: 50px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  background: #fff;
  .basic_img {
    width: 15%;
  }
  .basic_info {
    width: 35%;
    height: 100%;
    .info_inp {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .info_set {
        margin-top: 4%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 44%;
        margin-left: 3%;
        margin-right: 3%;
        img {
          margin-right: 10px;
          width: 1rem;
          height: 1.1875rem;
        }
        .btn {
          width: 100%;
        }
      }
    }
  }
  .basic_resume {
    border-left: 1px solid #000000;
    width: 50%;
    padding-left: 2%;
    .resume_input {
      margin-top: 1%;
    }
    .el-button {
      margin-top: 2%;
      margin-left: 90%;
    }
  }
}
.table {
  padding-top: 40px;
  background: #fff;
  width: 100%;
  .el-table {
    margin-left: 5%;
    width: 90%;
  }
}
.next {
  display: flex;
  background: #fff;
  height: 60px;
  .el-button {
    margin: auto;
  }
}
.basicDialog {
  .el-dialog__body {
    margin-left: 20%;
    width: 60%;
    .el-date-editor {
      width: 100%;
    }
    .el-form-item__label {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/claim/basic.vue